import React, { createContext, useState } from "react";
import AuthorizationInfo from "./models/user/AuthorizationInfo";
import {
  setAuthorizationToken,
  removeAuthorizationToken,
  getAuthorizationInfo
} from "./utilities/tokenUtilities";

interface UserContextProps {
  user: AuthorizationInfo;
  loginUser: (authorizationToken: string) => void;
  logoutUser: () => void;
}

interface UserContextProviderProps {
  children: React.ReactNode;
}

const getUser = () => {
  let authorizationInfo = getAuthorizationInfo();
  if (authorizationInfo) {
    authorizationInfo.isAuthenticated = true;
  } else {
    authorizationInfo = { isAuthenticated: false } as AuthorizationInfo;
  }

  return authorizationInfo;
};

const logoutFunction = () => {
  const logoutUrl = process.env.REACT_APP_AAI_LOGOUT_URL || "";
  const loginUrl = process.env.REACT_APP_AAI_LOGIN_URL || "";
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      if (
        this.responseText.includes(
          "Unable to determine the IDP that logged you in. You have been logged out of your local session."
        )
      ) {
        window.location.replace(loginUrl + "?logoutError=true");
      } else {
        const responseText = this.responseText.replace(
          '<body onload="document.forms[0].submit()">',
          '<body style="background-color: #044c92;" onload="document.forms[0].submit()">'
        );

        document.open();
        document.write(responseText);
        document.close();
      }
    }
  };

  xhttp.withCredentials = true;
  xhttp.open("GET", logoutUrl, true);
  xhttp.send();
};

const UserContext = createContext<UserContextProps>({} as UserContextProps);

export const UserContextProvider = ({
  children
}: UserContextProviderProps): JSX.Element => {
  const [user, setUser] = useState<AuthorizationInfo>(getUser());

  const loginUser = (authorizationToken: string) => {
    setAuthorizationToken(authorizationToken);

    const authorizationInfo = getAuthorizationInfo();
    if (authorizationInfo) {
      authorizationInfo.isAuthenticated = true;
      setUser(authorizationInfo);
    }
  };

  const logoutUser = () => {
    removeAuthorizationToken();
    setUser(previousState => ({
      ...previousState,
      isAuthenticated: false
    }));
    logoutFunction();
  };

  const context = {
    user: user,
    loginUser: loginUser,
    logoutUser: logoutUser
  };

  return (
    <UserContext.Provider value={context}>{children}</UserContext.Provider>
  );
};

export default UserContext;
